import { CreatedByRelationship } from './Common'

export const caseCommentMapSF = {
  direction: 'in',
  Id: 'id',
  CommentBody: 'comment',
  CreatedDate: 'createdDate',
  ...CreatedByRelationship
}

export interface CaseComment {
  id: string
  createdBy?: {
    id: string
    lastName: string
    firstName: string
    name: string
  }
  createdById?: string
  createdDate?: string
  comment: string
}
